module.exports = __webpack_public_path__ + "static/img/banner.0fa69868.jpg";